export default "__VITE_ASSET__Ce$kCK2T__"